var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"file-thumbnail"},[_c('div',{staticClass:"icon"},[_c('img',{attrs:{"src":_vm.getFileIcon(_vm.contentType)}})]),_c('div',{staticClass:"filename"},[_vm._v(_vm._s(_vm.fileName))])])
}
var staticRenderFns = []

export { render, staticRenderFns }